export default {"src":"/_next/static/media/logo-ministere-de-la-culture.dfcad09f.svg","height":89,"width":64};